import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  SetGuestActualDepartureTime as SetGuestActualDepartureTimeGenerated,
  SetGuestActualDepartureTimeVariables as SetGuestActualDepartureTimeVariablesGenerated,
} from "core/queries/__generated__/SetGuestActualDepartureTime";

export interface SetGuestActualDepartureTimeVariables
  extends SetGuestActualDepartureTimeVariablesGenerated {}
export interface SetGuestActualDepartureTimeResponse
  extends SetGuestActualDepartureTimeGenerated {}

export const setGuestActualDepartureTime = gql`
  mutation SetGuestActualDepartureTime(
    $inquiryId: ID!
    $actualDepartureTime: RFC3339DateTime!
    $channel: String
  ) {
    setGuestActualDepartureTime(
      inquiryId: $inquiryId
      actualDepartureTime: $actualDepartureTime
      channel: $channel
    ) {
      inquiry {
        id
        checkOutTime
        guestActualDepartureTime {
          id
          actualDepartureTime
          channel
        }
      }
    }
  }
`;

interface UseSetGuestActualDepartureTimeOptions {
  awaitRefetchQueries?: boolean;
  refetchQueries?: string[];
}

export const useSetGuestActualDepartureTime = ({
  awaitRefetchQueries = false,
  refetchQueries = [],
}: UseSetGuestActualDepartureTimeOptions) =>
  useMutation<
    SetGuestActualDepartureTimeResponse,
    SetGuestActualDepartureTimeVariables
  >(setGuestActualDepartureTime, {
    awaitRefetchQueries,
    refetchQueries,
  });
